import { VFC } from "react";

import ComingSoon from "components/ComingSoon";
import CursorPaginationTableControlsView from "components/pagination/CursorPaginationTableControlsView";
import TableView, { TableViewColumns } from "components/TableView";

interface BrokerShippersIndexTableViewProps {
  items: [];
  paginationOptions: {
    next: () => void;
    prev: () => void;
    setTake: (take: number) => void;
    take: number;
    page: number;
    total: number;
  };
  isLoading?: boolean;
}

const BrokerShippersIndexTableView: VFC<BrokerShippersIndexTableViewProps> = ({
  items,
  paginationOptions,
  isLoading,
}) => {
  const columns: TableViewColumns<{}> = [];

  return (
    <>
      <ComingSoon hideMessage />
      <TableView
        tableProps={{ style: { borderCollapse: "separate" } }}
        columns={columns}
        items={items}
        isLoading={isLoading}
      />
      <CursorPaginationTableControlsView {...paginationOptions} />
    </>
  );
};

export default BrokerShippersIndexTableView;
